
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x",
      function () {
        return require("private-next-pages/x.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x"])
      });
    }
  